import { useMutation } from '@tanstack/react-query';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { documentWorkflowControllerInviteAuthorisedSignatoryMutation } from '@dealstack/shared/lib/backendClient/@tanstack/react-query.gen';

export const useInviteAuthorisedSignatory = () => {
	return useMutation({
		mutationKey: [
			API_PATHS.DEAL_DEALID_MIP_PROGRAMMEID_DOCUMENT_WORKFLOW_DOCUMENTWORKFLOWINSTANCEID_INVITE_AUTHORISED_SIGNATORY_POST,
		],
		...documentWorkflowControllerInviteAuthorisedSignatoryMutation(),
	});
};
